/* eslint-disable max-len */
import React, { useState } from 'react';
import { getProjectByID, getMercurxProjectRequestAction } from '../../store/project/projectActions';
import { connect } from 'react-redux';
import { useEffect } from 'react';
import { setWalletAccountData } from '../../store/wallet/walletActions';
import { Button, Card, Col, Container, Row, Alert } from 'react-bootstrap';
import { checkAllConditionForStake, checkRegisterConditionForProject } from '../../helpers/verificationHelper';
import wallet from '../../helpers/wallet';
import detectEthereumProvider from '@metamask/detect-provider';
import './ProjectDetail.scss';
import MercurXProjectInfo from '../../components/MercurXProjectInfo/MercurXProjectInfo';
import MercurXIcons from '../../components/MercurXIcons/MercurXIcons';
import { swapTokenModalAction } from '../../store/project/projectActions';
import { buyTokenModalAction } from '../../store/token/tokenActions';
import { registrationTokenRequestAction } from '../../store/token/tokenActions';
import MercurXBuyTokenModal from '../../components/MercurXBuyTokenModal/MercurXBuyTokenModal';
import MercurXSwapTokenModal from '../../components/MercurXSwapTokenModal/MercurXSwapTokenModal';
import ProjectFlow from '../../components/MercurXProjectFlow/ProjectFlow';
import MercurXSpinner from '../../components/MercurXSpinner/MercurXSpinner';
import NftSaleProjectDetail from './NftSaleProjectDetail';
import {
  accountDetailsRequestAction
} from '../../store/account/userActions';
 
export const checkUserVerified = (user) => {
  return user?.is_active?.toString().toLowerCase() === 'true';
};
 
export const checkUserKyc = (user) => {
  const kycData = user?.result?.kyc || user?.kyc;
  return kycData?.[0]?.kyc_status === 'Approved';
};
 
function ProjectDetail({ ...props }) {
  const {
    project,
    accountDetailsRequest,
    mercurxProject,
    provider,
    accounts,
    ethereum,
    setWalletAccount,
    user,
    buyTokenModalRequest,
    registrationTokenRequest,
    swapTokenModalRequest,
    getMercurxProjectRequest,
    tierData,
  } = props;
 
  const item = props.project || project;
  const routeProjectId = props.match?.params?.id;
  const pathname = props.location?.pathname?.toLowerCase() || '';
  const isNftSaleProject = pathname.startsWith('/sales/nft/project/');
  const percentRaised = Math.min(Math.max(Number(item?.percent_raised) || 0, 0), 100);
 
  const [stake, setStake] = useState(false);
  const [swap, setSwap] = useState(false);
  const [signature, setSignature] = useState('');
  const [error, setError] = useState('');
  const [chainId, setChainId] = useState();
  const [message, setMessage] = useState('');
  const [signedMessage, setSignedMessage] = useState('');
  const [verified, setVerified] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [fetchError, setFetchError] = useState(null);
  const [retryCount, setRetryCount] = useState(0);
  
  const todayUTC = new Date().toISOString();
 
  // localStorage'dan KYC requirement ayarını al
  const getKycRequirement = () => {
    const saved = localStorage.getItem('requireKyc');
    return saved ? JSON.parse(saved) : false;
  };
 
  // KYC ayarı ile birlikte verification kontrolü yapan fonksiyon
  const checkStakeConditions = (user, accounts, isControlProject = false, project = null) => {
    const requireKyc = getKycRequirement();
    return checkAllConditionForStake(user, accounts, isControlProject, project, requireKyc);
  };
 
  // Registration için verification kontrolü yapan fonksiyon
  const checkRegistrationConditions = (user, accounts, isControlProject = false, project = null) => {
    const requireKyc = getKycRequirement();
    return checkRegisterConditionForProject(user, accounts, isControlProject, project, requireKyc);
  };
 
  const fetchProjectData = async (showLoading = true) => {
    if (isNftSaleProject) {
      return;
    }
 
    if (showLoading) setIsLoading(true);
    setFetchError(null);
    
    try {
      const payload = { id: props.match.params.id };
      
      await Promise.all([
        props.getProjectByID(payload),
        getMercurxProjectRequest(),
        accountDetailsRequest()
      ]);
      
      setRetryCount(0);
      
    } catch (err) {
      setFetchError(`Error occurred while loading project data: ${err.message}`);
      
      if (retryCount < 3) {
        setTimeout(() => {
          setRetryCount(prev => prev + 1);
          fetchProjectData(false);
        }, 2000);
      }
    } finally {
      if (showLoading) setIsLoading(false);
    }
  };
 
  const handleModalClose = async () => {
    buyTokenModalRequest(false);
    swapTokenModalRequest(false);
    
    setStake(false);
    setSwap(false);
    
    await fetchProjectData();
    
    setTimeout(async () => {
      await fetchProjectData(false);
    }, 1000);
    
    setTimeout(async () => {
      const currentItem = props.project || project;
      const isEmpty = !currentItem || !currentItem.id || Object.keys(currentItem).length === 0;
      
      if (isEmpty) {
        await fetchProjectData(false);
      }
    }, 3000);
  };
 
  useEffect(() => {
    if (!isNftSaleProject) {
      fetchProjectData();
    }
  }, [props.match.params.id, isNftSaleProject]);
 
  useEffect(() => {
    if (isNftSaleProject) {
      return;
    }
 
    if (provider?.on) {
      const handleAccountsChanged = (newAccounts) => {
        if (accounts?.[0] !== newAccounts?.[0]) {
          setWalletAccount(newAccounts);
          fetchProjectData(false);
        }
      };
      
      const handleChainChanged = (_hexChainId) => {
        setChainId(_hexChainId);
        fetchProjectData(false);
      };
 
      const handleDisconnect = () => {
        disconnect();
      };
 
      provider.on('accountsChanged', handleAccountsChanged);
      provider.on('chainChanged', handleChainChanged);
      provider.on('disconnect', handleDisconnect);
 
      return () => {
        if (provider.removeListener) {
          provider.removeListener('accountsChanged', handleAccountsChanged);
          provider.removeListener('chainChanged', handleChainChanged);
          provider.removeListener('disconnect', handleDisconnect);
        }
      };
    }
  }, [provider, accounts, isNftSaleProject]);
 
  if (isNftSaleProject) {
    return <NftSaleProjectDetail projectId={Number(routeProjectId)} />;
  }
 
  const stakeSetup = () => {
    setStake(true);
  };
 
  const swapSetup = () => {
    setSwap(true);
  };
 
  const handleShow = () => {
    buyTokenModalRequest(true);
  };
 
  const handleRegistration = () => {
    const project_id = project?.id;
    try {
      const payload = { project_id };
      registrationTokenRequest(payload);
    } catch (err) {
      setError(`Registration error: ${err.message}`);
    }
  };
 
  const handleShowSwap = () => {
    swapTokenModalRequest(true);
  };
 
  const connectWallet = async () => {
    try {
      await wallet.connectWallet();
    } catch (err) {
      setError(`Wallet connection error: ${err.message}`);
    }
  };
 
  const addMerxTokenFunction = async () => {
    try {
      const provider = await detectEthereumProvider();
      const wasAdded = await provider.sendAsync({
        method: 'wallet_watchAsset',
        params: {
          type: 'ERC20',
          options: {
            address: item?.token?.address,
            symbol: item?.token?.symbol,
            decimals: item?.token?.decimals,
          },
        },
      });
 
      if (wasAdded) {
      } else {
      }
    } catch (error) {
      setError(`Token addition error: ${error.message}`);
    }
  };
 
  const refreshState = () => {
    setChainId();
    setMessage('');
    setSignature('');
    setVerified(undefined);
    setError('');
    setFetchError(null);
  };
 
  const disconnect = async () => {
    try {
      await wallet.disconnectWallet();
    } catch (err) {
    }
  };
 
  const handleRetry = () => {
    setRetryCount(0);
    fetchProjectData();
  };
 
  const getTokenSymbol = () => {
    return item?.token?.symbol?.toUpperCase() || 'TOKEN';
  };
 
  const getTokenPrice = () => {
    return item?.token?.price_in_usd || 0;
  };
 
  const getTokenPriceInMercurx = () => {
    return item?.token?.price_in_mercurx || 0;
  };
 
  const getTokenDistribution = () => {
    return item?.token?.distribution || 0;
  };
 
  if (isLoading && !item) {
    return (
      <Container className="mt-5 d-flex justify-content-center">
        <div className="text-center">
          <MercurXSpinner />
          <p className="mt-3">Loading project data...</p>
          {retryCount > 0 && (
            <p className="text-muted">Retry attempt: {retryCount}/3</p>
          )}
        </div>
      </Container>
    );
  }
 
  if (fetchError && !item) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">
          <Alert.Heading>An Error Occurred</Alert.Heading>
          <p>{fetchError}</p>
          <hr />
          <Button variant="outline-danger" onClick={handleRetry}>
            Try Again
          </Button>
        </Alert>
      </Container>
    );
  }
 
  if (!item || !item.token || !project || !mercurxProject || !item.id) {
    const isEmptyItem = item && typeof item === 'object' && Object.keys(item).length === 0;
    
    if (isEmptyItem) {
      if (!isLoading) {
        fetchProjectData();
      }
    }
    
    if (fetchError) {
      return (
        <Container className="mt-5">
          <Alert variant="danger">
            <Alert.Heading>An Error Occurred</Alert.Heading>
            <p>{fetchError}</p>
            <hr />
            <Button variant="outline-danger" onClick={handleRetry}>
              Try Again
            </Button>
          </Alert>
        </Container>
      );
    }
    
    if (isLoading || (!project && !mercurxProject) || isEmptyItem) {
      return (
        <Container className="mt-5 d-flex justify-content-center">
          <div className="text-center">
            <MercurXSpinner />
            <p className="mt-3">
              {isEmptyItem ? 'Reloading project data...' : 'Loading project data...'}
            </p>
            {retryCount > 0 && (
              <p className="text-muted">Retry attempt: {retryCount}/3</p>
            )}
          </div>
        </Container>
      );
    }
    
    if (project && item && !item?.token && item.id) {
      return (
        <Container className="mt-5">
          <Alert variant="warning">
            <Alert.Heading>Token Information Not Found</Alert.Heading>
            <p>Token information could not be found for this project. This may occur temporarily after large volume purchases.</p>
            <small className="text-muted">
              Project ID: {item.id} | Token status: {item.token ? 'Exists but empty' : 'Completely missing'}
            </small>
            <hr />
            <Button variant="outline-warning" onClick={handleRetry}>
              Reload
            </Button>
          </Alert>
        </Container>
      );
    }
    
    return <MercurXSpinner />;
  }
 
  // KYC requirement ayarını kontrol et
  const requireKyc = getKycRequirement();
 
  return (
    <>
      {(!project || !mercurxProject) && !fetchError ? (
        <Container className="mt-5 d-flex justify-content-center">
          <div className="text-center">
            <MercurXSpinner />
            <p className="mt-3">Loading additional data...</p>
          </div>
        </Container>
      ) : (
        <Container className="mt-5 px-5">
          {(error || fetchError) && (
            <Alert variant="danger" dismissible onClose={() => {setError(''); setFetchError(null);}}>
              {error || fetchError}
            </Alert>
          )}
          
          {isLoading && (
            <Alert variant="info">
              <div className="d-flex align-items-center">
                <MercurXSpinner />
                <span className="ms-2">Operation in progress...</span>
              </div>
            </Alert>
          )}
 
          {/* KYC Setting Info Banner */}
          {requireKyc && (
            <Alert variant="info" className="mb-3">
              <div className="d-flex align-items-center">
                <MercurXIcons name="BiInfoCircle" size={20} />
                <span className="ms-2">
                  <strong>KYC Verification Required:</strong> KYC verification is currently required for all operations.
                  You can change this setting in the Profile Settings tab.
                </span>
              </div>
            </Alert>
          )}
 
          <Row>
            <Card className="project-detail-card col-md-12 col-sm-12">
              <Card.Header className="bg-white">
                <div
                  className="project-detail-name-div d-flex justify-content-between
              align-items-center col-md-6 col-sm-4"
                >
                  <Row className="">
                    <div>
                      <img
                        alt="project_logo"
                        src={process.env.REACT_APP_API_URL + '/projects/' + item.id + '/logo'}
                        height={92}
                        width={92}
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                    </div>
                  </Row>
                  <Row className="col-md-12 col-lg-12 mx-0">
                    <Card.Title className="text-fs-head-lg"> {item.name}</Card.Title>
                    <Card.Text className="text-fs-body-sm">
                      {getTokenSymbol()}</Card.Text>
                  </Row>
                </div>
                <div className="project-detail-price-div">
                  <Card.Text className="text-fs-body-sm mb-0">PRICE</Card.Text>
                  <Card.Title
                    className="text-fs-head-md
                  mb-0"
                  >
                    {getTokenPrice().toLocaleString('tr-TR', {
                      style: 'currency',
                      currency: 'USD',
                      currencyDisplay: 'symbol',
                      useGrouping: true,
                      minimumFractionDigits: 4,
                    })}
                  </Card.Title>
                  <Card.Text className="text-fs-body-md">
                    {getTokenPriceInMercurx()} MERX
                  </Card.Text>
                </div>
              </Card.Header>
              <Card.Body>
                <div className="project-detail-name-div">
                  <Card.Text className="text-fs-body-md">Round</Card.Text>
                  <Card.Title className="text-fs-head-md">{item.active_round}</Card.Title>
                </div>
                <div className="project-detail-price-div">
                  <Card.Text className="text-fs-body-md">Time Left</Card.Text>
                  <Card.Title className="text-fs-head-md">{item.round_time_left}</Card.Title>
                </div>
              </Card.Body>
 
              <div>
                <div className="progress mb-2 rounded-pill">
                  <span
                    className="progress-value
                    text-t-body-color-light"
                  >
                    {percentRaised}%
                  </span>
                  <div
                    className="progress-bar
                    rounded-pill"
                    style={{
                      width: percentRaised + '%',
                    }}
                  ></div>
                </div>
              </div>
              <Card.Body className="project-detail-card-body">
                <div className="project-detail-name-div">
                  <Card.Text>TOKEN DISTRIBUTION</Card.Text>
                  <Card.Title className="text-fs-head-md">
                    {getTokenDistribution().toLocaleString('tr-TR', {
                      useGrouping: true,
                      minimumSignificantDigits: 1,
                    })}
                  </Card.Title>
                </div>
 
                <div className="project-detail-price-div">
                  <Card.Text>TOTAL RAISED</Card.Text>
                  <Card.Title>
                    {(item.total_raised || 0).toLocaleString('tr-TR', {
                      style: 'currency',
                      currency: 'USD',
                      currencyDisplay: 'symbol',
                      useGrouping: true,
                      minimumFractionDigits: 4,
                    })}
                    /{' '}
                    {(item.target_raised || 0).toLocaleString('tr-TR', {
                      style: 'currency',
                      currency: 'USD',
                      currencyDisplay: 'symbol',
                      useGrouping: true,
                      minimumFractionDigits: 4,
                    })}
                  </Card.Title>
                </div>
              </Card.Body>
              <Card.Footer className="bg-white">
                <div className="project-detail-footer-left-div">
                  <Card.Title>Want to buy {getTokenSymbol()} token ?</Card.Title>
                </div>
                <div className="project-detail-footer-right-div">
                  <Row>
                    <Col>
                      {checkStakeConditions(user, accounts) &&
                       project?.is_active == 'active' ? (
                        <Button
                          variant="primary"
                          onClick={addMerxTokenFunction}
                          className="token-button"
                          disabled={isLoading}
                        >
                          Add {getTokenSymbol()}{' '}
                        </Button>) : (
                        <Button className="token-button" variant="primary" disabled={true}>
                          Add {getTokenSymbol()}{' '}
                        </Button>
                      )}
                    </Col>
                    {project?.round_registration?.end_date > todayUTC ? (
                      <Col>
                        {checkRegistrationConditions(user, accounts) &&
                          project?.is_active == 'active' &&
                          !user?.projects?.some(project => project.project_id === item.id)
                          ? (
                            <Button
                              className="token-button"
                              variant="primary"
                              onClick={handleRegistration}
                              disabled={isLoading}
                            >
                              Registration
                            </Button>
                          ) : (
                            <Button className="token-button" variant="primary" disabled={true}>
                              Registration
                            </Button>
                          )}
                      </Col>
                    ) : (
                      <Col>
                        {checkStakeConditions(user, accounts) &&
                          project?.is_active == 'active' ? (
                          <Button
                            className="token-button"
                            variant="primary"
                            onClick={() => {
                              stakeSetup();
                              handleShow();
                            }}
                            disabled={isLoading}
                          >
                            {getTokenSymbol()} / BNB
                          </Button>
                        ) : (
                          <Button className="token-button" variant="primary" disabled={true}>
                            {getTokenSymbol()} / BNB
                          </Button>
                        )}
                      </Col>
                    )}
                    {item?.token?.symbol != 'MerX' ? (
                      <Col>
                        {project?.round_registration?.end_date <= todayUTC ? (
                          <Col>
                            <></>
                          </Col>
                        ) : (
                          <Col>
                            {checkStakeConditions(user, accounts) &&
                              project?.is_active == 'active' ? (
                              <Button
                                className="token-button"
                                variant="primary"
                                onClick={() => {
                                  swapSetup();
                                  handleShowSwap();
                                }}
                                disabled={isLoading}
                              >
                                Swap {getTokenSymbol()} / MERX
                              </Button>
                            ) : (
                              <Button className="token-button" variant="primary" disabled={true}>
                                Swap {getTokenSymbol()} / MERX
                              </Button>
                            )}
                          </Col>
                        )}
                      </Col>
                    ) : (
                      <></>
                    )}
                  </Row>
                </div>
              </Card.Footer>
            </Card>
          </Row>
 
          <div className="mt-3">
            <Row>
              <Col>
                <div className="border rounded p-2">
                  <div className="d-flex align-items-center border-bottom-0">
                    {user ? (
                      <MercurXIcons name="MdDone" color="#28a745" size="24" />
                    ) : (
                      <MercurXIcons name="MdPriorityHigh" color="#ffc107" size="24" />
                    )}
                    <span className="h6 mb-0 mx-auto">
                      {user ? 'Account Enabled' : 'Account Disabled'}
                    </span>
                  </div>
                </div>
              </Col>
              <Col>
                <div className="border rounded p-2">
                  <div className="d-flex align-items-center border-bottom-0">
                    {accounts ? (
                      <MercurXIcons name="MdDone" color="#28a745" size="24" />
                    ) : (
                      <MercurXIcons name="MdPriorityHigh" color="#ffc107" size="24" />
                    )}
                    <span className="h6 mb-0 mx-auto">
                      {accounts ? 'Wallet Enabled' : 'Wallet Disabled'}
                    </span>
                  </div>
                </div>
              </Col>
              <Col>
                <div className="border rounded p-2">
                  <div className="d-flex align-items-center border-bottom-0">
                    {checkUserVerified(user) ? (
                      <MercurXIcons name="MdDone" color="#28a745" size="24" />
                    ) : (
                      <MercurXIcons name="MdPriorityHigh" color="#ffc107" size="24" />
                    )}
                    <span className="h6 mb-0 mx-auto">
                      {checkUserVerified(user) ? 'Mail Verified' : 'Mail Not Verified'}
                    </span>
                  </div>
                </div>
              </Col>
              <Col>
                <div className="border rounded p-2">
                  <div className="d-flex align-items-center border-bottom-0">
                    {requireKyc ? (
                      checkUserKyc(user) ? (
                        <MercurXIcons name="MdDone" color="#28a745" size="24" />
                      ) : (
                        <MercurXIcons name="MdPriorityHigh" color="#ffc107" size="24" />
                      )
                    ) : (
                      <MercurXIcons name="MdInfo" color="#6c757d" size="24" />
                    )}
                    <span className="h6 mb-0 mx-auto">
                      {requireKyc ? (
                        checkUserKyc(user) ? 'Kyc Approved' : 'Kyc Required'
                      ) : (
                        'Kyc Optional'
                      )}
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
 
            {checkStakeConditions(user, accounts) && stake ? (
              <MercurXBuyTokenModal onClose={handleModalClose} />
            ) : (
              <div></div>
            )}
            {checkStakeConditions(user, accounts) && swap ? (
              <MercurXSwapTokenModal onClose={handleModalClose} />
            ) : (
              <div></div>
            )}
          </div>
          <ProjectFlow {...props} />
          <MercurXProjectInfo {...props} />
        </Container>
      )}
    </>
  );
}
 
const mapStateToProps = (state) => {
  return {
    provider: state.walletReducer.provider,
    ethereum: state.walletReducer.ethereum,
    accounts: state.walletReducer.accounts,
    user: state.userReducer.user,
    project: state.projectReducer.project,
    mercurxProject: state.projectReducer.mercurxProject,
    tierData: state.tierReducer.tierData,
  };
};
 
const mapDispatchToProps = (dispatch) => {
  return {
    accountDetailsRequest: (payload) => {
      dispatch(accountDetailsRequestAction(payload));
    },
    setWalletAccount: (payload) => {
      dispatch(setWalletAccountData(payload));
    },
    getProjectByID: (payload) => {
      dispatch(getProjectByID(payload));
    },
    buyTokenModalRequest: (payload) => {
      dispatch(buyTokenModalAction(payload));
    },
    registrationTokenRequest: (payload) => {
      dispatch(registrationTokenRequestAction(payload));
    },
    swapTokenModalRequest: (payload) => {
      dispatch(swapTokenModalAction(payload));
    },
    getMercurxProjectRequest: (payload) => {
      dispatch(getMercurxProjectRequestAction(payload));
    },
  };
};
 
export default connect(mapStateToProps, mapDispatchToProps)(ProjectDetail);